// LIVE DATA / TEST DATA (1.468.0), for the screens that only ever showed
// one mode's worth and never said which.
//
// Asked for on 23 Sep 2026: "It might be an idea to be able to filter
// between live and test data with the default being Live when the site is
// in live mode." Live is the default because it is the admin's own mode,
// which is what the server answers for when nothing is asked.
//
// SHOWN ONLY WHILE THE SITE IS LIVE. In Test mode there is nothing to
// choose: an admin in Test may not look at Live data, so a filter would
// offer one option and a refusal. Demo likewise.
//
// A FILE OF ITS OWN because the payments panel is a module of its own and
// cannot reach into AdminApp.jsx for it. The two labels and the test
// colour are inlined here rather than imported for the same reason - this
// component offers exactly two modes, and MODE_LABEL/MODE_COLOR in
// AdminApp.jsx cover all three for everything else.
//
// Kept apart from QueueSwitch, which reads in competitions: "Working on
// the Live queue" is about what you are running, this is about what you
// are looking at.
import React from "react";

const LABEL = { live: "Live", test: "Test" };
const TEST_COLOR = "var(--accent-blue)";

export default function DataModeFilter({ value, onChange, siteIsLive, what }) {
  if (!siteIsLive) return null;
  const onTest = value === "test";
  return (
    <div
      data-mode-filter={value}
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 8,
        flexWrap: "wrap",
        margin: "0 0 10px",
        padding: "6px 9px",
        borderRadius: 8,
        border: `1px solid ${onTest ? TEST_COLOR : "var(--border-color)"}`,
      }}
    >
      <span style={{ fontSize: 12.5, opacity: 0.8 }}>Showing</span>
      <div role="group" aria-label={`Which data — ${what}`} style={{ display: "inline-flex", gap: 4 }}>
        {["live", "test"].map((m) => (
          <button
            key={m}
            type="button"
            aria-pressed={value === m}
            onClick={() => onChange(m)}
            style={{
              fontWeight: value === m ? 700 : 400,
              borderColor: value === m && m === "test" ? TEST_COLOR : undefined,
            }}
          >
            {LABEL[m]}
          </button>
        ))}
      </div>
      {onTest && (
        <span style={{ fontSize: 12, color: TEST_COLOR }}>Test {what} only. Nothing here is real.</span>
      )}
    </div>
  );
}
